import { css } from '@microsoft/fast-element';

export const CompanyApproveStyles = css`
  .hidden {
    display: none;
  }

  .company-grid-approval {
    display: grid;
    grid-template-columns: 25% 55% 20%;
    align-items: center;
    height: 50px;
    border-bottom: 1px solid #2e3339;
  }

  .company-data-name {
    width: 180px;
  }

  zero-text-field::part(root) {
    align-items: normal;
  }

  .date-field {
    text-align: right;
  }
`;
